/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PrimaryButton from '../Buttons/PrimaryButton';

const ImagePicker = (props) => {

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (file !== null) {
            props.onChange(file);

            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result)
            }
            reader.readAsDataURL(file);
        }

    }, [file])

    const onImagePick = () => {
        document.getElementById(props.id).click();
    }

    const onImageSelect = (event) => {
        setFile(event.target.files[0]);
    }

    const removeImage = () => {
        setFile(null);
        setPreview(null);
    }

    return (
        <div className='image-picker' >
            <label style={{ marginBottom: '0px' }}>{props.title}</label>
            <div className='image-container' >
                <img className='img' src={`${preview ? preview : '/image-preview.jpg'}`} alt='picked' />
                {
                    !preview && <div className='image-upload-actions'>
                        <PrimaryButton onClick={onImagePick} type='button' >Upload</PrimaryButton>
                    </div>
                }
                {
                    preview && <div className='image-upload-actions' >
                        <PrimaryButton onClick={onImagePick} type='button' >Edit</PrimaryButton>
                        <PrimaryButton onClick={removeImage} type='button' >Remove</PrimaryButton>
                    </div>
                }
            </div>
            <input id={props.id} name={props.id} style={{ display: 'none' }} type='file' onChange={onImageSelect} />
        </div>
    )

}

export default ImagePicker;